import React from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyGenericErrorPage = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-arj-generic-error-page", jiraPriority: 'ondemand' */ './index'
		),
);

export const AsyncLazyGenericErrorPage = () => (
	<Placeholder name="async-arj-generic-error-page" fallback={<Spinner />}>
		<LazyGenericErrorPage />
	</Placeholder>
);
